/** ตัวช่วยสร้าง id — ใช้ได้ทั้งบน browser และ Workers (WebCrypto มีทั้งสองที่) */

export function newId(): string {
  return crypto.randomUUID()
}

/** id สั้นสำหรับ node/edge/block ที่ต้องอ่านง่ายในกราฟ */
export function newShortId(prefix: string): string {
  return `${prefix}_${crypto.randomUUID().slice(0, 8)}`
}

/** key ของขั้นตอนหนึ่งครั้ง = nodeId + ลำดับครั้งที่เข้าโหนดนี้ (รองรับ flow ที่วนกลับ) */
export function makeStepKey(nodeId: string, visitIndex: number): string {
  return `${nodeId}~${visitIndex}`
}

export function parseStepKey(stepKey: string): { nodeId: string; visitIndex: number } | null {
  const idx = stepKey.lastIndexOf('~')
  if (idx <= 0) return null
  const nodeId = stepKey.slice(0, idx)
  const visitIndex = Number(stepKey.slice(idx + 1))
  if (!Number.isInteger(visitIndex) || visitIndex < 0) return null
  return { nodeId, visitIndex }
}
